import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ResourcesListComponent } from '@app/modules/shared/components/resources-list/resources-list.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-list-resources',
  templateUrl: './modal-list-resources.component.html',
  styleUrls: ['./modal-list-resources.component.css']
})
export class ModalListResourcesComponent implements OnInit, AfterViewInit{

  resources;
  @ViewChild('resourceList', {static: false}) resourceListComponent: ResourcesListComponent;
  constructor(public modal: NgbActiveModal) { }

  ngAfterViewInit(): void {
   
  }

  ngOnInit(): void {
    
  }
}
